var productDetailInit = function () {
    $('.product-detail-slider').first().slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });

    var productUid = $('.product-uid-input').val();
    $.ajax({
        type: 'GET',
        url: App.prototype.apiAddress + 'products/'+productUid,
        dataType: "json",
        success: function( response ) {

            var features = response.features;
            var orderInputs = response.product_order_inputs;

            var selectionsHolder = $('.feature-selections');
            var orderInputsHolder = $('.order-inputs');

            selectionsHolder.empty();
            orderInputsHolder.empty();

            App.prototype.selectedProductUi = productUid;
            $('.product-uid-input').val(productUid);

            features.forEach(function (item) {

                if(item.type === "choose_one") {

                    App.prototype.selectedProductType = "choose_one";
                    App.prototype.buildSelect(item, selectionsHolder);

                }

                else if (item.type === "multiple") {

                    App.prototype.selectedProductType = "multiple";
                    App.prototype.buildCheckbox(item, selectionsHolder);

                }

            });

            orderInputs.forEach(function (item) {

                App.prototype.buildOrderInput(item, orderInputsHolder);

            });
        }
    });
};
App.prototype.pageDetector('product-detail-page', productDetailInit);
